import cn from "classnames";
import styles from "./videoContainer.module.scss";

interface VideoContainerProps {
    src?: string;
}

const VideoContainer: React.FC<VideoContainerProps> = ({ src }) => {
    if (!src) {
        return null;
    }

    return (
        <div className={cn(styles.iframeContainer)}>
            <iframe src={src} id="videoPlayer" allowFullScreen></iframe>
        </div>
    );
};

export default VideoContainer;